import { type SelectionsMachine } from '../../machine/selection-machine';
import { getClickTarget } from '../mouse-input/utils/get-click-target';
import { type SelectionInput } from '../types';

export function createContextMenuInput(machine: SelectionsMachine): SelectionInput {
  function onContextMenu(event: PointerEvent) {
    const state = machine.getState();

    // ignore if we're currently editing.
    if (state.isEditing) {
      return;
    }

    const x = event.clientX;
    const y = event.clientY;
    const target = getClickTarget(x, y);

    if (target.type === 'cell') {
      event.preventDefault();

      machine.dispatch({
        type: 'selectCell',
        cell: target.position,
        source: 'mouse',
        contextMenuTrigger: { x, y },
      });
    }
  }

  return {
    setup() {
      document.addEventListener('contextmenu', onContextMenu);
    },

    dispose() {
      document.removeEventListener('contextmenu', onContextMenu);
    },
  };
}
